import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import { FieldViewType } from "../viewType";
import fieldsDictionary from "../fieldsDictionary";
import TextFieldEdit from "./edit";
import TextFieldDetail from "./detail";
import TextFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type text en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Text() {
    return _jsx(_Fragment, { children: "Text" });
}
var field = fieldsType.text;
fieldsDictionary.registerField(FieldViewType.EDIT, field, TextFieldEdit);
fieldsDictionary.registerField(FieldViewType.DETAIL, field, TextFieldDetail);
fieldsDictionary.registerField(FieldViewType.LIST, field, TextFieldList);
